import styled from "@emotion/styled";

export const Text = styled.span`
  font-weight: 500;
  color: inherit;
  font-size: 20px;
`;
export const Button = styled.button`
  font-family: inherit;
  font-weight: 400;
  color: inherit;
  font-size: 20px;
  background-color: transparent;
  border: none;
  margin-left: 10px;
  cursor: pointer;
`;
